import {
  ApplicationConfig,
  ErrorHandler,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { sesionReducer } from './data/store/session/sesion.reducer';
import { setHeaderInterceptor } from './core/interceptors/set-hearder.interceptor';
import { uiLoadingReducer, uiReducer } from './data/store/ui/ui.reducer';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { errorHttpInterceptor } from './core/interceptors/error-http.interceptor';

import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

Bugsnag.start({
  apiKey: '9ac0191268c9a8c35de67290ade3d9db',
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([
        setHeaderInterceptor,
        loaderInterceptor,
        errorHttpInterceptor,
      ])
    ),
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          ripple: true,
          darkModeSelector: '.light-theme',
        },
      },
      ripple: true,
    }),
    provideAnimationsAsync(),
    provideStore({
      'sesion-management': sesionReducer,
      'sesion-ui-management': uiReducer,
      'sesion-ui-loading': uiLoadingReducer,
    }),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    provideEffects([]),
  ],
};
